import React from "react";
import { Button } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";

const BulkDownloadConfirmationModal = ({
  isOpen,
  onClickYes,
  onClosePopup,
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClosePopup}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        Confirmation
      </DialogTitle>

      <DialogContent>
        <div>Do you want to proceed with download ?</div>
        <div
          style={{ display: "flex", justifyContent: "end", marginTop: "1rem" }}
        >
          <Button onClick={() => onClosePopup(false)} color="primary">
            NO
          </Button>
          <Button onClick={onClickYes} color="primary">
            YES
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BulkDownloadConfirmationModal;
